import { createFormContext } from '@mantine/form';

import { ContractPricingFormType } from 'store/pricing/types';

export const [ContractPricingFormProvider, useContractPricingFormContext, useContractPricingForm] =
  createFormContext<ContractPricingFormType>();
